<template>
 <!-- @mouseenter="mouseenter" @mouseleave="mouseleave" -->
  <div class="bannerBox" @mouseenter="mouseenter" @mouseleave="mouseleave">
    <div class="swiper bannerSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide"
          v-for="(item, index) in bannerList" :key="item.id">
          <a :href="item.jumpLink?item.jumpLink:'javascript:;'">
           <img :src="item.cover" alt="" />
          </a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="hoverbanner" v-show="show">
      <div class="text_one">
        连环画作为一种中国独具特色的综合性传统叙事艺术样式，是属于人民大众的艺术，深受少年儿童的喜爱，是几代人童年的珍贵记忆，堪称“小人书、大天地”，也是中华优秀传统文化的具体呈现。
      </div>
      <div class="text_two">
        武汉市少年儿童图书馆的连环画收藏始于1950年，目前馆藏近2万种、10万册。这些连环画跨越年代长、馆藏数量大、题材品种多，内容包罗万象，堪称我馆藏书的“镇馆之宝”。为让更多读者领略连环画的独特风采，我馆对这些珍贵的馆藏陆续进行数字化，全新上线了“连环画数字阅览室”，以专题数字图书形式推出，便于读者阅读。并通过连环画独特的艺术魅力，引导青少年厚植文化自信、延续文化基因，共同繁荣并创造属于我们这个时代的新文化。
      </div>
         
      </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import {getHomeBannerList} from '@/api/basics/banner'

import remToggle from "@/utils/rem-toggle.js";
export default {
  
  mixins: [remToggle],
  data() {
    return {
      bannerList: [],
      show:false,
      swiperInstance: null,  // 保存 swiper 实例
      currentIndex: 0  // 当前激活的 slide 索引
    };
  },
  mounted(){
    this.initSwiper();
  },
  // updated(){
  //   var bannerBox = new Swiper(".bannerSwiper", {
  //     autoplay: {
  //       delay: 5000, //2秒切换一次
  //       disableOnInteraction: false,
  //     },
  //     loop:true,
  //     // autoplay:false,
  //     pagination: {
  //       el: ".swiper-pagination",
  //       clickable: true,
  //     },
  //   });
  // },
  created() {
    this.getBanner()
  },
  methods: {
    initSwiper(){
     if (this.bannerList.length > 0) {
        this.swiperInstance = new Swiper(".bannerSwiper", {
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
            on: {
            // 监听 slide 切换事件，更新当前索引
            slideChange: () => {
              if (this.swiperInstance) {
                // 获取真实索引（考虑 loop 模式）
                let realIndex = this.swiperInstance.realIndex;
                this.currentIndex = realIndex;
                console.log('当前索引:', realIndex);
              }
            }
          }
        });
            // 初始化时设置当前索引
        this.currentIndex = this.swiperInstance.realIndex;
      }
    },
    getBanner(){
      const params = {
        module:222
      }
      getHomeBannerList(params).then(res=>{
        console.log('轮播图',res);
        this.bannerList = res.data.rows
        // console.log("this.bannerList",this.bannerList);
         this.$nextTick(() => {
          if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true); // 销毁旧实例
          }
          this.initSwiper();
        })
      })
    },
    mouseenter(){
       if (this.currentIndex === 0) {
        // 可选：暂停自动播放
        if (this.swiperInstance && this.swiperInstance.autoplay) {
          this.swiperInstance.autoplay.stop();
        }
        this.show = true;
      }
    },
    mouseleave(){
      // 鼠标离开时隐藏 hoverbanner 并恢复自动播放
      if (this.currentIndex === 0) {
        if (this.swiperInstance && this.swiperInstance.autoplay) {
          this.swiperInstance.autoplay.start();
        }
        this.show = false;
      } else {
        // 如果不是第一张图，确保 show 为 false
        this.show = false;
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前销毁 swiper 实例
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
  }
};
</script>

<style scoped lang="less">
@import "/src/css/base.css";
.bannerBox {
  width: 13.63rem;
  position: relative;
  margin-bottom: 0.65rem;
  margin: auto;
  overflow: hidden;
  margin-top: 0.5rem;
  // padding: 0 0.1rem; // 整屏两侧留呼吸距
  box-sizing: border-box;
}
.bannerSwiper {
  width: 13.63rem;
}
.bannerBox .bannerSwiper .swiper-slide {
  width: 13.63rem;
  height: 4.83rem;
}
.bannerBox .bannerSwiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
.bannerSwiper /deep/.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 1%;
}
.bannerSwiper /deep/.swiper-pagination-bullet {
  width: 0.28rem;
  height: 0.06rem;
  border-radius: 0.02rem;
  background: rgba(255, 255, 255, 0.29);
  margin: 0 0.04rem;
}
.bannerSwiper /deep/.swiper-pagination-bullet-active {
  background-color: rgb(255, 255, 255);
}
// .hoverbanner {
//   position: fixed;
//   z-index: 99;
//   bottom: 25%;
//   left: 17%;
//   max-width: 1250px;
//   height: 380px;
//   margin: auto;
//   img{
//     max-width: 100%;
//     height: 100%;
//   }
// }
.hoverbanner {
  // border: 1px solid red;
  position: absolute;          /* 1. 相对于 bannerBox 定位 */
  left: 50%;                   /* 2. 水平居中 */
  top: 50%;                    /* 2. 垂直居中 */
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 92%;                  /* 3. 自适应宽度，最大不超过设计稿 1250 */
  width: 12.5rem;
  height: 0;                   /* 3. 用 padding 撑比例 */
  padding-top: 30%;            /* 380/1250 ≈ 30.4% */
  overflow: hidden;
  background-image: url('@/assets/image/hoverbanner.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // img {
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   width: 100%;
  //   height: 100%;
  //   object-fit: contain;
  // }
  .text_one {
    width: 92%; 
    position: absolute;
    left: 5%;
    top: 0.30rem;  
    font-size: 0.2rem;
    line-height: 0.4rem;
    color: #333333;
    margin-top: 0.5rem;
    text-indent: 0.2rem;
  }
  .text_two {
    width: 92%; 
    position: absolute;
    left: 5%;
    top: 1.22rem;
    font-size: 0.2rem;
    line-height: 0.4rem;
    color: #333333;
    margin-top: 0.45rem;
    text-indent: 0.2rem;
  }
}
// @media (max-width: 768px) {
//   .hoverbanner {
//     width: 96%;
//     padding-top: 40%;   /* 小屏可把比例拉高一点 */
//   }
// }
</style>
